/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
    selector: 'app-modal-footer',
    template: '<div #footer style="display: flex"><ng-content></ng-content></div>'
})
export class ModalFooterComponent {
    /**
     * Reference to the 1st panel in the html.
     */
    @ViewChild('footer', { static: true }) public footer: ElementRef;
}
